// extracted by mini-css-extract-plugin
module.exports = {"lecture_container":"lecturePlayer_lecture_container__UILhB","iframe_wrapper":"lecturePlayer_iframe_wrapper__1hqF3","shield":"lecturePlayer_shield__1std0"};